import { PHARMACY_LOCAL } from '../constants/pharmacy-local.constant';
import { CustomNotification } from '../../../../../v2-components/Notification';
import { Notification } from '../../../../../v2-components/Notification/constant';

export const openCloseHandle = ({ schedule, time }) => {
	if (
		(schedule.open === PHARMACY_LOCAL.CLOSED && schedule.close !== PHARMACY_LOCAL.CLOSED) ||
		(schedule.close === PHARMACY_LOCAL.CLOSED && schedule.open !== PHARMACY_LOCAL.CLOSED)
	) {
		CustomNotification({
			type: Notification.type.error,
			message: Notification.message.error,
			description: `Debe corregir el horario del día ${
				PHARMACY_LOCAL.SCHEDULE_DAYS[schedule.day - 1]
			}, no puedes tener un horario abierto y el otro cerrado`,
		});
		return false;
	}

	return true;
};
